import React, { useRef, useState } from 'react'
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import { enumUtil } from '../../../../utils/Enum';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest';
// import Modal from 'react-bootstrap/Modal';
// import AmountFormatter from '../../../../utils/AmountFormatter';
// import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
// import isNull from '../../../../utils/NullChecking';
import Loader from '../../../shared/Loader/Loader';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import noData from "./../../../../assets/img/NoDataFound.svg"
import NotificationHandler from '../../../../utils/NotificationHandler';
import { isChildWindow } from '../../../../utils/Constants';
import ViewFileFormattedText from '../../../../utils/ViewFileFormattedText';

const useLoadPDFDataWithTypeChildWindow = () => {
  const API_URL_Wasabi = enumUtil.controller.Wasabi
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [isLoading, setIsLoading] = useState(true)
  const [pdfFile, setPdfFile] = useState(null);
//   const [isLoadingPDFType, setIsLoadingPDFType] = useState(false)
  const [viewFileData, setViewFileData] = useState([]);
  const [contentType, setContentType] = useState('')

  const ViewPdf = (filePath) => {
    // console.log("OpenChildCustomView filePath", filePath, filePath, !pdfFile , filePath && !pdfFile);

    setPdfFile(null)
    if (!filePath && pdfFile) {
      setIsLoading(false);
      return;
    }
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      "BucketPath": filePath
    }, 'Download').then((response) => {
      setIsLoading(false)
      if (response.type === 'application/txt') {
        const blob = response;
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result;
          // setTxtFile(content);
        };
        reader.readAsText(blob, 'utf-8');
      } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        // setImgFile(objectURL)
      } else if (response.type === 'application/tiff') {

      }
      else {
        let file = new Blob([response]);
        const fileUrl = URL.createObjectURL(file);
        setPdfFile(fileUrl)
      }
    //   setShowPDF(true)
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }
  const viewERAFile = (propsData) => {
    const { Data, TableName, Name, Controller, Link } = propsData;
      // console.log("Child propsData",propsData)
      if (Data?.FileType === "HR") {
          NotificationHandler("Please Select Correct File", enumUtil.enumtoaster.error);
      } else {
          setViewFileData([]);
          setIsLoading(true);
          let requestPayload = {
              "ID": "",
              "TableName": TableName
          };
          if (Name === 'EDIReport') {
              requestPayload.ID = Data.DownloadFileID;
          } else if (Name === 'Activity') {
              requestPayload.ID = Data;
          }else if (Name === 'SubmissionHistory') {
              requestPayload.ID = Data.EDIClaimBatchID;
          }
          else if (Name === 'Payment') {
              requestPayload.ID = Data.FileID;
          }
          else if (Name === 'TransactionInformation') {
              requestPayload.ID = Data.DownloadFileID+"";
          }
          else if (Name === 'ClaimAccountSummary') {
              requestPayload.ID = Data.EDIClaimBatchID+"";
          }
          else if (Name === 'ElectronicSubmission') {
              requestPayload.ID = Data+"";
          }
          else if (Name === 'Eligibity') {
              requestPayload.ID = Data?.EligibilityLogID+"";
              requestPayload.Value = "271";
          
          }
          else if (Name === 'ActivityGrid') {
              requestPayload.ID = Data+"";
          }
          ServerRequestProtected(Controller + Link, 'post', requestPayload)
              .then((response) => {
                  setIsLoading(false);
                  setViewFileData(response);
              })
              .catch((error) => {
                  setIsLoading(false);
                  // close()
                  NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
              });
      }
  };

  const handleOpenWithPdfType = (type, data) => {
    setContentType(type);
    if(type === 'ViewBillingBatchDocument'){
      ViewPdf(data);
    }
    if(type === 'ViewERA'){
      viewERAFile(data);
    }
  }
  
  let pdfContent =
    <>
      <div className="ar_print-header">
        <div className='pdf_perview clr_cccccc d-flex justify-content-between align-items-center'>
          {/* {isLoadingPDFType ? <Loader /> : null} */}
          <p className='heading fs-16'>Preview</p>
          <div className="d-flex align-items-center gap-2">
          </div>
        </div>
      </div>
      {
        <>
          {/* {isLoading ?  : null} */}
          {isLoading ? <Loader /> :
            <div className='za_content my-2 hover-scrollbar'>
              {pdfFile ?
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <Viewer fileUrl={pdfFile}
                    defaultScale={SpecialZoomLevel?.PageWidth}
                    plugins={[defaultLayoutPluginInstance]} />
                </Worker> :
                <div className='no_data'>
                  <div>
                    <img src={noData} />
                    <p>No Data Found</p>
                  </div>
                </div>}
            </div>
          }
        </>}
    </>;
  // console.log("Child contentType", contentType)
  let pdfDivType = isChildWindow ?
    (contentType === 'ViewERA' ?
    <div className='ar_view_EOB-child-window h-100'>
      {isLoading ? <Loader /> :<></>}
      <div className='d-flex justify-content-between align-items-center ps-3 mb-2'>
          <p className='heading fs-14 dark-clr'>Results</p>
        </div>
        <div className="">
          <ol className=''>
            {viewFileData?.map((item, index) => (
              <li className="list-AdvInfo" key={index}>
                <ViewFileFormattedText originalText={item} />
              </li>
            ))}
          </ol>
        </div>
    </div>:
    <div className='ar_view_EOB-child-window h-100'>
      {pdfContent}
    </div>)
    : <></>;
  return { pdfDivType, handleOpenWithPdfType }
}

export default useLoadPDFDataWithTypeChildWindow